import React from 'react';
import type { WorkflowEdgeProps } from 'flow/service/graph';
import BaseEdge from '../BaseEdge';


export default function SkeletonEdge(props: WorkflowEdgeProps) {
  return (
    <BaseEdge
      {...props}
      style={{
        stroke: 'var(--cl-gray-300)',
        strokeDasharray: '6',
      }}
    />
  );
}
